import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
const router = new Router({
// export default new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/",
      name: "/",
      redirect: "/Login",
    },

    // 菜单页面
    {
      path: "/Home",
      name: "/Home",
      component: () => import("./components/Home.vue"),
      children: [
        // 首页
        {
          path: "/index",
          name: "首页",
          component: () => import("./components/Index.vue"),
        },
        // 设备信息
        {
          path: "/deviceInfo",
          name: "设备信息",
          component: () => import("./components/DevManager.vue"),
        },
        // 角色管理
        {
          path: "/system/role",
          name: "角色管理",
          component: () => import("./components/system/RoleManage.vue"),
        },
        // 账户管理
        {
          path: "/system/account",
          name: "账户管理",
          component: () => import("./components/system/AccontManage.vue"),
        },
        // 修改密码页
        {
          path: "/system/changePwd",
          name: "修改密码",
          component: () => import("./components/system/Editpsw.vue"),
        },
        // 表格页
        {
          path: "/table",
          name: "table",
          component: () => import("./components/system/Table.vue"),
        },

        // 开关
        {
          path: "/switchControl",
          name: "开关控制",
          component: () => import("./components/SwitchControl.vue"),
        },
        // 报警管理
        {
          path: "/alarmManage",
          name: "报警管理",
          component: () => import("./components/Alarm.vue"),
        },
        // 摄像头管理
        {
          path: "/deviceConfig/camera",
          name: "摄像头配置",
          component: () => import("./components/system/MonitorManage.vue"),
        },
        // 3d模型管理
        {
          path: "/deviceConfig/threeDimensional",
          name: "3d配置",
          component: () => import("./components/system/3dManage.vue"),
        },
        // 图片配置
        {
          path: "/deviceConfig/photo",
          name: "图片配置",
          component: () => import("./components/system/UploadImage.vue"),
        },
      ],
    },
    // 登录页
    {
      path: "/Login",
      name: "/Login",
      component: () => import("./components/Login.vue"),
    },
    // 忘记密码页
    {
      path: "/Forget",
      name: "/Forget",
      component: () => import("./components/ForgetPsw.vue"),
    },
    // 地图页
    {
      path: "/map",
      name: "map",
      component: () => import("./components/Map.vue"),
    },
    {
      path: "/mapSX",
      name: "mapSX",
      component: () => import("./components/MapSX.vue"),
    },
    // 城市设备页
    {
      path: "/Citydevice",
      name: "Citydevice",
      component: () => import("./components/CityDevice.vue"),
      
    },
    // 更多模块页
    {
      path: "/ModelList",
      name: "ModelList",
      component: () => import("./components/ModelList.vue"),
      
    },
    // 模块详情页
    {
      path: "/ModelDetail",
      name: "ModelDetail",
      component: () => import("./components/ModelDetail.vue"),
      
    },
    // 在线设备详情
    {
      path: "/detail",
      name: "detail",
      component: () => import("./components/drive/moreDetail.vue"),
    },
    // 拖拽
    {
      path: "/drag",
      name: "drag",
      component: () => import("./components/drive/drag.vue"),
    },
    // 图片查看
    {
      path: "/imglook",
      name: "imglook",
      component: () => import("./components/ImageLook.vue"),
    },
    // 设备监控
    {
      path: "/monitor",
      name: "monitor",
      component: () => import("./components/Monitor.vue"),
    },
    // 3d展示
    {
      path: "/3DShow",
      name: "3DShow",
      component: () => import("./components/3DShow.vue"),
    },
    // 安卓3d页面
    { 
      path: "/3D",
      name: "3D",
      component: () => import("./components/3d.vue"),
    },
    // ai问答页
    { 
      path: "/AI",
      name: "AI",
      component: () => import("./components/AI.vue"),
    },
    // {
    //   path: "/three",
    //   name: "three",
    //   component: () => import("./components/Three-supan.vue"),
    // },
    {
      path: "/swiper",
      name: "swiper",
      component: () => import("./components/swiper.vue"),
    },
    {
      path: "/zoom",
      name: "zoom",
      component: () => import("./components/zoom.vue"),
    },
    {
      path: "/mirror",
      name: "mirror",
      component: () => import("./components/mirror.vue"),
    },
  ],
});
router.beforeEach((to, from, next) => {
  if (to.meta.refresh) {
    // 如果路由的meta字段中包含refresh属性，表示需要刷新页面
   
    console.log('11')
    next() 
    window.location.reload();
  } else {
    next() // 正常路由跳转
  }
})
export default router
// 以下代码解决路由地址重复的报错问题(一劳永逸)
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
